function Hero() {
  return (
    <div className="bg-hero-mobile md:bg-hero-tab lg:bg-hero bg-no-repeat bg-cover bg-[center_50%] h-[50vh] md:h-[80vh] lg:h-[82vh]" id="homeNav">
      <img src="/images/hero2.jpg" alt="hero-img" className="hidden w-full"/>
    </div>
  )
}

export default Hero